module.exports = __webpack_public_path__ + "img/fb-driver.9407d6d9.svg";